(function () {
  'use strict';

  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-AU') : n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + s;
  }
  var COL_NAMES = { alloy: 'Raw alloy', black: 'Black', white: 'White' };
  var STYLE_LABEL = { std: 'standard canopy', jo: 'jack-off canopy', lc79: 'LC79 canopy', dog: 'dog box' };
  var STYLE_SHORT = { std: 'Standard', jo: 'Jack-Off', lc79: 'LC79', dog: 'Dog Box' };

  function stockLine(q, available, low) {
    if (q === null) return '<span class="ok">Available to order</span> — call to check what’s on the floor.';
    if (!available || q <= 0) return '<span class="oos">Out of stock</span> — contact us for an ETA, or call to check the floor.';
    if (q < low) return '<span class="low">Low stock</span> — ' + q + ' left at Burton. Call to hold one.';
    return '<span class="ok">In stock at Burton</span> — drive home today.';
  }

  /* ---------- home configurator ---------- */
  function initConfigurator(root) {
    var sec = root.closest('.shopify-section') || document;
    var dataEl = sec.querySelector('[data-cfg-data]');
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items.length) { root.style.display = 'none'; return; }
    var low = parseInt(root.getAttribute('data-low'), 10) || 3;
    var styleBtns = root.querySelectorAll('[data-cfg-style] button');
    var sizeWrap = root.querySelector('[data-cfg-size]');
    var colBtns = root.querySelectorAll('[data-cfg-col] button');
    var state = { t: 'std', s: null, c: 'alloy' };

    function sizesFor(t) {
      var seen = {}, out = [];
      items.forEach(function (i) { if (i.t === t && !seen[i.s]) { seen[i.s] = 1; out.push(i.s); } });
      out.sort(function (a, b) {
        var na = parseInt(a, 10), nb = parseInt(b, 10);
        if (isNaN(na) || isNaN(nb)) return a === 'Full' ? -1 : 1;
        return na - nb;
      });
      return out;
    }
    function find(t, s, c) {
      for (var k = 0; k < items.length; k++) { var i = items[k]; if (i.t === t && i.s === s && i.c === c) return i; }
      return null;
    }
    // hide style buttons with no products
    styleBtns.forEach(function (b) { if (!sizesFor(b.getAttribute('data-v')).length) b.style.display = 'none'; });
    if (!sizesFor(state.t).length) {
      for (var k = 0; k < styleBtns.length; k++) { var v = styleBtns[k].getAttribute('data-v'); if (sizesFor(v).length) { state.t = v; break; } }
    }

    function render() {
      var sizes = sizesFor(state.t);
      if (sizes.indexOf(state.s) === -1) {
        // prefer a mid-size default for canopies
        state.s = sizes.indexOf('1000') > -1 && state.t === 'std' ? '1000' : sizes[0];
      }
      styleBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === state.t)); });
      sizeWrap.innerHTML = sizes.map(function (s) {
        var lab = /^\d+$/.test(s) ? s + 'mm' : s;
        return '<button type="button" data-v="' + s + '" aria-pressed="' + (s === state.s) + '"><span>' + lab + '</span></button>';
      }).join('');
      sizeWrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { state.s = b.getAttribute('data-v'); render(); });
      });
      if (!find(state.t, state.s, state.c)) {
        var cs = ['alloy', 'black', 'white'];
        for (var k = 0; k < cs.length; k++) { if (find(state.t, state.s, cs[k])) { state.c = cs[k]; break; } }
      }
      colBtns.forEach(function (b) {
        var v = b.getAttribute('data-v');
        b.disabled = !find(state.t, state.s, v);
        b.setAttribute('aria-pressed', String(v === state.c));
      });
      var hit = find(state.t, state.s, state.c);
      if (!hit) return;
      var sizeLab = /^\d+$/.test(state.s) ? state.s + 'mm ' : state.s + ' ';
      root.querySelector('[data-cfg-price]').textContent = money(hit.p);
      root.querySelector('[data-cfg-desc]').textContent = sizeLab + STYLE_LABEL[state.t] + ', ' + COL_NAMES[state.c].toLowerCase();
      root.querySelector('[data-cfg-avail]').innerHTML = stockLine(hit.q, hit.a, low);
      root.querySelector('[data-cfg-cap]').textContent = sizeLab + STYLE_SHORT[state.t] + ' — ' + COL_NAMES[state.c];
      var img = root.querySelector('[data-cfg-img]');
      if (hit.i) { img.src = hit.i; img.alt = hit.title; }
      root.querySelector('[data-cfg-variant]').value = hit.v;
      root.querySelector('[data-cfg-link]').href = hit.u;
      var add = root.querySelector('[data-cfg-add]');
      add.disabled = !hit.a;
      add.querySelector('span').textContent = hit.a ? 'Add to cart' : 'Sold out';
    }
    styleBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.t = b.getAttribute('data-v'); state.s = null; render(); });
    });
    colBtns.forEach(function (b) {
      b.addEventListener('click', function () { if (!b.disabled) { state.c = b.getAttribute('data-v'); render(); } });
    });
    render();
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('.gal .main img');
    root.querySelectorAll('[data-thumbs] button').forEach(function (b, idx, all) {
      b.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-src'); }
        all.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
    // variant radios (e.g. colour on accessories)
    var radios = root.querySelectorAll('[data-variant-select] input');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (priceEl) priceEl.textContent = r.getAttribute('data-price');
        var ok = r.getAttribute('data-available') === 'true';
        if (addBtn) { addBtn.disabled = !ok; addBtn.querySelector('span').textContent = ok ? 'Add to cart' : 'Sold out'; }
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.qty [data-q]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-q'), 10);
    input.value = Math.max(min, v);
  });

  /* ---------- feature carousel ---------- */
  function initCarousel(section) {
    var track = section.querySelector('[data-track]');
    if (!track) return;
    section.querySelectorAll('[data-car]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.pcard');
        var step = card ? card.getBoundingClientRect().width + 20 : 380;
        track.scrollBy({ left: step * parseInt(b.getAttribute('data-car'), 10), behavior: 'smooth' });
      });
    });
  }

  /* ---------- tag filters (accessories) ---------- */
  function initTagFilters(wrap) {
    var grid = document.querySelector('[data-grid]');
    if (!grid) return;
    var btns = wrap.querySelectorAll('button');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        grid.querySelectorAll('.pcard').forEach(function (card) {
          var tags = ' ' + (card.getAttribute('data-tags') || '') + ' ';
          card.style.display = (f === 'all' || tags.indexOf(' ' + f + ' ') > -1) ? '' : 'none';
        });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-configurator]').forEach(initConfigurator);
    (scope || document).querySelectorAll('[data-product]').forEach(initGallery);
    (scope || document).querySelectorAll('.det').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-tag-filters]').forEach(initTagFilters);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
